import React, { useEffect, useState } from "react";
import styles from "./css/Login.module.css";
import { Divider, IconButton, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { GoogleLogin } from "@react-oauth/google";

import {
  setAddress,
  setAppartment,
  setCity,
  setCountry,
  setEmail,
  setFirstName,
  setLastName,
  setZipCode,
} from "../../redux/slices/userSlice.js";

const Login = () => {
  const navigate = useNavigate(); // Initialize navigate function
  const language = useSelector((state: any) => state.language.value);

  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async () => {
    try {
      const body = {
        email: username,
        password: password,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/auth/login`,
        body
      );

      localStorage.setItem("accessToken", response.data.accessToken);
      localStorage.setItem("refreshToken", response.data.refreshToken);

      // Fetch and store user profile in Redux
      await handleMe(response.data.accessToken);

      console.log("Login successful", response.data);
    } catch (err) {
      setError("Invalid username or password");
      console.error("Login failed", err);
    }
  };

  const cartItems = localStorage.getItem("cartItems");

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes("access_token")) {
      const token = new URLSearchParams(hash.substring(1)).get("access_token");

      if (token) {
        (async () => {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_SERVER_URL}/auth/yandex-login`,
              { token }
            );

            localStorage.setItem("accessToken", response.data.accessToken);
            localStorage.setItem("refreshToken", response.data.refreshToken);

            // Fetch user profile and store in Redux
            await handleMe(response.data.accessToken);

            console.log("Yandex Login successful", response.data);

            navigate("/");
          } catch (err) {
            console.error("Yandex login failed", err);
          }
        })();
      }
    }
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes("access_token")) {
      const token = new URLSearchParams(hash.substring(1)).get("access_token");

      if (token) {
        (async () => {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_SERVER_URL}/auth/yandex-login`,
              { token }
            );

            localStorage.setItem("accessToken", response.data.accessToken);
            localStorage.setItem("refreshToken", response.data.refreshToken);

            // Fetch user profile and store in Redux
            await handleMe(response.data.accessToken);

            console.log("Yandex Login successful", response.data);
            navigate("/");
          } catch (err) {
            console.error("Yandex login failed", err);
          }
        })();
      }
    }
  }, []);

  const handleMe = async (accessToken: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/auth/profile`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      console.log("Me info:", response.data);

      if (response.status === 200) {
        const user = response.data; // Assuming response.data contains user details

        dispatch(setFirstName(user.firstName || ""));
        dispatch(setLastName(user.lastName || ""));
        dispatch(setEmail(user.email || ""));
        dispatch(setAddress(user.address?.address || ""));
        dispatch(setCity(user.address?.city || ""));
        dispatch(setCountry(user.address?.selectedCountry || ""));
        dispatch(setZipCode(user.address?.zipCode || ""));
        dispatch(setAppartment(user.address?.appartment || ""));
      }

      if (cartItems && JSON.parse(cartItems).length > 0) {
        navigate("/checkout");
      } else {
        navigate("/admin/orders");
      }
    } catch (err) {
      setError("Info fetch failed");
      console.error("Fetching profile failed", err);
    }
  };

  const reduxState = useSelector((state: any) => state.address);

  useEffect(() => {
    console.log("Updated Redux State:", reduxState); // Log state after it updates
  }, [reduxState]);

  const test = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/books`
      );

      console.log(response.data);
    } catch (err) {
      setError("Invalid username or password");
      console.error(err);
    }
  };

  useEffect(() => {
    test();
  }, []);
  return (
    <div className={styles.productContainer}>
      <div className={styles.productInfo}>
        <div className={styles.frame}>
          <span className={styles.productTitle7}>
            {language == "EN" ? "Welcome back!" : "Bine ai revenit!"}
          </span>
          <div className={styles.form}>
            <div className={styles.inputs}>
              <div className={styles.inputField}>
                <TextField
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": {
                      height: "inherit",
                      backgroundColor: "transparent",
                      "&::before, &::after": {
                        display: "none",
                        content: "none",
                        borderBottom: "none",
                      },
                      "&:hover:not(.Mui-disabled, .Mui-error)::before": {
                        borderBottom: "none !important",
                      },
                      "&.Mui-focused::after": {
                        borderBottom: "none !important",
                      },
                    },
                  }}
                  hiddenLabel
                  id=""
                  placeholder="Email"
                  variant="outlined"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </div>
            <div className={styles.inputField9}>
              <div className={styles.inputFieldA}>
                <TextField
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": {
                      height: "inherit",
                    },
                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::before ":
                      {
                        content: "none",
                        display: "none",
                        border: "unset",
                      },

                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                      {
                        content: "none",
                        display: "none",
                        border: "unset",
                      },
                  }}
                  hiddenLabel
                  type={showPassword ? "text" : "password"} // Toggle between text and password type
                  id="filled-hidden-label-normal"
                  placeholder={language == "EN" ? "Password" : "Parola"}
                  variant="filled"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        sx={{ paddingRight: "10px" }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          {error && <span className={styles.error}>{error}</span>}
          <span
            className={styles.lostPassword}
            onClick={() => navigate("/admin/password_forgot")}
          >
            {language === "EN" && "Forgot password?"}

            {language === "RO" && "Ai uitat parola?"}
          </span>
          <span
            className={styles.lostPassword}
            onClick={() => navigate("/register")}
          >
            {language === "EN" && (
              <>
                Don't have an account?{" "}
                <span style={{ textDecoration: "underline" }}>Sign up</span>
              </>
            )}

            {language === "RO" && (
              <>
                Nu ai cont?{" "}
                <span style={{ textDecoration: "underline" }}>
                  Inregistreaza-te
                </span>
              </>
            )}
          </span>
          <button className={styles.buttonE} onClick={handleLogin}>
            <span className={styles.addToCartF}>
              {language === "EN" && "Log in"}

              {language === "RO" && "Logare"}
            </span>
          </button>
        </div>
      </div>

      <div className={styles.orLoginContainer}>
        <div className={styles.orLogin}>
          <Divider className={styles.divider} />
          <span className={styles.text}>Or login with</span>
          <Divider className={styles.divider} />
        </div>

        <GoogleLogin
          onSuccess={async (credentialResponse) => {
            if (credentialResponse.credential) {
              try {
                const response = await axios.post(
                  `${process.env.REACT_APP_SERVER_URL}/auth/google-login`,
                  { token: credentialResponse.credential }
                );

                // Store access & refresh tokens
                localStorage.setItem("accessToken", response.data.accessToken);
                localStorage.setItem(
                  "refreshToken",
                  response.data.refreshToken
                );

                // Fetch user profile and store in Redux
                await handleMe(response.data.accessToken);

                console.log("Google Login successful", response.data);
              } catch (err) {
                console.error("Google login failed", err);
              }
            }
          }}
          onError={() => {
            console.error("Google Login Failed");
          }}
        />
      </div>
    </div>
  );
};

export default Login;
